import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
} from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: window.COSMA_CONFIG?.cognitoUserPoolId || process.env.REACT_APP_COGNITO_USER_POOL_ID || "ap-south-1_qhACMCjKo",
  ClientId: window.COSMA_CONFIG?.cognitoClientId || process.env.REACT_APP_COGNITO_CLIENT_ID || "6sdf5bm11f60ge679ti04fkhue",
};

const userPool = new CognitoUserPool(poolData);

export function cognitoLogin(email, password) {
  return new Promise((resolve, reject) => {
    const authDetails = new AuthenticationDetails({
      Username: email,
      Password: password,
    });
    const cognitoUser = new CognitoUser({ Username: email, Pool: userPool });

    cognitoUser.authenticateUser(authDetails, {
      onSuccess(session) {
        const idToken = session.getIdToken();
        const payload = idToken.decodePayload();
        resolve({
          token: idToken.getJwtToken(),
          userId: payload.sub,
          email: payload.email,
          userName: payload.name || payload.email,
          role: payload["custom:role"] || "",
          // product: from Cognito JWT if set, otherwise falls back to build-time env in auth.js
          product: payload["custom:cosmaProduct"] || "",
          customerId: payload["custom:customerId"] || "",
          subscriptionId: payload["custom:subscriptionId"] || "",
          subscriptionStatus: payload["custom:subscriptionStatus"] || "",
          orgId: payload["custom:orgId"] || "",
          consentGiven: payload["custom:consentGiven"] || "",
        });
      },
      onFailure(err) {
        reject(err);
      },
      newPasswordRequired(_userAttributes, _requiredAttributes) {
        reject({ code: "NewPasswordRequired", cognitoUser });
      },
      mfaRequired(_challengeName, _challengeParameters) {
        reject({ code: "MFARequired", cognitoUser });
      },
    });
  });
}

export function cognitoForgotPassword(email) {
  return new Promise((resolve, reject) => {
    const cognitoUser = new CognitoUser({ Username: email, Pool: userPool });
    cognitoUser.forgotPassword({
      onSuccess() { resolve(); },
      onFailure(err) { reject(err); },
    });
  });
}

export function cognitoConfirmPassword(email, code, newPassword) {
  return new Promise((resolve, reject) => {
    const cognitoUser = new CognitoUser({ Username: email, Pool: userPool });
    cognitoUser.confirmPassword(code, newPassword, {
      onSuccess() { resolve(); },
      onFailure(err) { reject(err); },
    });
  });
}

export function cognitoSignOut() {
  const user = userPool.getCurrentUser();
  if (user) user.signOut();
}
